import { type GradeConfig, type GradeReasonProperties } from 'types'

import { type AppDispatch } from '..'

import { actions } from './application.slices'

export const switchManualEntryScreen = () =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(actions.switchManualEntryScreen())
  }

export const setKeyboardWithClosureOpen = (open: boolean) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(actions.setKeyboardWithClosureOpen({ open }))
  }

export const setGradeConfigs = (gradeConfigs: GradeConfig[]) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(actions.setGradeConfigs({ gradeConfigs }))
  }

export const setPrintConfig = (printConfig: string[]) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(actions.setPrintConfig({ printConfig }))
  }

export const setGradeReasonProperties = (gradeReasonProperties: GradeReasonProperties[]) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(actions.setGradeReasonProperties({ gradeReasonProperties }))
  }
